export default "__VITE_ASSET__CTq3Tcxu__"